export default function selectJiraIssuesById(state, { source }) {
  return state.integrations.thirdPartyData[source].issues.byId
}
